import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "animate.css";
import WOW from "wowjs";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import CloudAutomation from "./pages/CloudAutomation";
import ApplicationTransformation from "./pages/ApplicationTransformation";
import Contact from "./pages/Contact";
import NetworkImplementation from "./pages/NetworkImplementation";

const App = () => {
  useEffect(() => {
    // Initialize WOW.js
    new WOW.WOW().init();
  }, []);

  return (
    <Router>
      <div>
        <Header />
        <main>
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/CloudAutomation" element={<CloudAutomation />} />
            <Route path="/ApplicationTransformation" element={<ApplicationTransformation />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/NetworkImplementation" element={<NetworkImplementation />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
